import { useQuery } from "react-query";
import PartnersShowcaseService from "#/api/partnersShowcase/partnersShowcase";
import { MilesPropertiesData } from "#/api/partnersShowcase/types";

export const useGetMilesProperties = () => {
  return useQuery<MilesPropertiesData[], Error>({
    queryKey: ["miles-properties"],
    queryFn: async () => {
      try {
        return await PartnersShowcaseService.getMilesProperties();
      } catch (error) {
        throw error;
      }
    },
    retry: false,
    staleTime: 1000 * 60 * 5,
  });
};
